import React from "react";
import { Col, Row, Button, Container, Card } from "react-bootstrap";
import Layout from "../components/layout";
import ServerProps from "../lib/serverProps";
import ContactUsForm from "../components/users/ContactUsForm";
import csrf from "../src/csrf";

const Page = ({ state, csrfToken }) => (
  <Layout
    title="Stride Equity - Contact Us - Investors - Startups - Scaleups"
    meta={{
      card: "summary_large_image",
      description:
        "Contact us today to discuss equity crowdfunding and find out how Stride Equity can help you achieve your aspirations or if you have other questions. ",
    }}
    state={state}
  >
    <div className="offset-header funding">
      <Container>
        <Row>
          <Col md={12}>
            <h1>Get in touch</h1>
            <hr className="black-line" />
          </Col>
          <Col md={6} sm={12}>
            <p>
              Want to know more about <br /> Stride Equity?
            </p>

            <p>We’d love to hear from you.</p>
          </Col>
          <Col md={6} sm={12}>
            <ContactUsForm csrfToken={csrfToken} />
          </Col>
        </Row>
      </Container>
    </div>
  </Layout>
);

export async function getServerSideProps({ req, res }) {
  await csrf(req, res);
  return {
    props: {
      state: await ServerProps.getState(req),
      csrfToken: req.csrfToken(),
    },
  };
}

export default Page;
